import { useWatchAsset } from 'wagmi'
import { toast } from 'react-toastify'
import { PropsWithChildren, useState } from 'react'
import { cn } from '@/lib/utils'
import { usePepperTokenConfig } from '@/hooks/pepper-contract/usePepperContract'
import { Button } from './ui/Button'
import { useRequireWalletConnection } from '@/hooks/useRequireWalletConnection'

type Props = PropsWithChildren<{
	className?: string
}>

const AddTokenButton = ({ className, children, ...rest }: Props) => {
	const [isLoading, setIsLoading] = useState(false)
	const { watchAssetAsync } = useWatchAsset()
	const config = usePepperTokenConfig()

	const addTokenToWallet = useRequireWalletConnection(() => {
		return watchAssetAsync({
			options: config,
			type: 'ERC20'
		})
	})

	const onBtnClick = async () => {
		try {
			setIsLoading(true)
			await addTokenToWallet()
		} catch (e) {
			toast.error('An error occurred while adding the token to your wallet')
		} finally {
			setIsLoading(false)
		}
	}

	return (
		<Button
			loading={isLoading}
			onClick={onBtnClick}
			className={cn('flex items-center justify-center leading-none', className)}
			{...rest}
		>
			{children}
		</Button>
	)
}

export default AddTokenButton
